module.exports = __webpack_public_path__ + "static/media/vein-legend.f3947e94.jpg";